import Slider from './Slider/Slider';
import './Clients.scss';

const Clients = () => {

    return (
        <>
            <div className='about__clients__section' id='need__section'>
                <Slider />
            </div>
        </>
    );
};

export default Clients;